import {
  GET_PAGINATED_TRENDING_TAGS_QUERY,
  GET_TERRITORIES_TRENDING_ALERT,
  GET_TERRITORY_PERFORMANCE_TOTAL_METRICS_QUERY,
} from './operations'
import type { TrendingTagsQueriesMap } from './types'

export const GRAPH_TRENDING_TAGS_QUERIES: TrendingTagsQueriesMap = {
  getTerritoryPerformanceTotalMetrics: GET_TERRITORY_PERFORMANCE_TOTAL_METRICS_QUERY,
  getPaginatedTrendingTags: GET_PAGINATED_TRENDING_TAGS_QUERY,
  getTerritoryTrendingAlert: GET_TERRITORIES_TRENDING_ALERT,
}
